import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export const ProductPreview: React.FC = () => {
  return <section className="py-24 px-4 md:px-8 bg-brand-cream/30" data-id="element-137">
      <div className="max-w-5xl mx-auto text-center" data-id="element-138">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-12" data-id="element-139">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-brand-primary mb-6" data-id="element-140">
            Todo lo que necesitás en un solo lugar
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="relative max-w-4xl mx-auto mb-12" data-id="element-141">
          <img src="https://cdn.magicpatterns.com/uploads/5hq296twpsLaDaYEzuM1mV/Guia_de_viandas_y_bonos_gratis.jpg" alt="Vista previa del producto y bonos" className="w-full h-auto rounded-3xl shadow-2xl" data-id="element-142" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} data-id="element-143">
          <Button data-id="element-144">QUIERO MI COPIA AHORA</Button>
        </motion.div>
      </div>
    </section>;
};